import useSWR from "swr";
import { useEffect, useState } from "react";
import { useDebounce } from "use-debounce";
import useHttp from "./useHttp";

type Config = {
    url: string,
    params?: any;
    dataSetter?: any,
    mapper?: any;
    setInitial?: any;
    revalidateOnFocus?: boolean;
    refreshInterval?: number;
};

export default function useFetcher(config: Config) {
    const [debouncedFilters] = useDebounce(config.params ? config.params : config.url, 300);
    const http = useHttp();
    const [pending, setPending] = useState(true);
    const args = config.params ? [config.url, config.params ? JSON.stringify(debouncedFilters) : null] : config.url;
    const {
        data,
        error,
        isValidating,
        mutate,
    } = useSWR(config.url ? args : null, (key, params) => {
        return http.get(key, config.params ? JSON.parse(params) : {}, {}, config.mapper);
    }, {
        shouldRetryOnError: true,
        revalidateOnFocus: config.revalidateOnFocus == undefined ? false : config.revalidateOnFocus,
        refreshInterval: config.refreshInterval,
    });

    useEffect(() => {
        if (data) {
            config.dataSetter && config.dataSetter(data.data);

            setPending(false);
        }
    }, [data]);

    return {
        data: data,
        pending: pending,
        error,
        isValidating,
        mutate
    };
}
